/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance, flow } from 'mobx-state-tree';
import { EmailTemplateModel, IEmailTemplateModel, Email, IEmail } from './models/emailTemplate.model';
import { AxiosResponse } from 'axios';
import axios from 'server';

const { model, array, string, number } = types;

export const EmailTemplatesTableStore = model('EmailTemplatesTableStore', {
  emailTempaltes: array(EmailTemplateModel),
  emailtemp: array(Email),
  filter: string,
  selectedId: number,
})
  .views((self) => ({
    get emailTempaltesView(): IEmailTemplateModel[] {
      if (!self.filter) {
        return self.emailTempaltes;
      }
      const regexp = new RegExp(self.filter, 'i');
      return self.emailTempaltes.filter(
        ({ id, sentEvent, bccTo, sendTo, templateSubject, templateBody, templateKeywords }) =>
          regexp.test(`${id}${sentEvent}${bccTo}${sendTo}${templateSubject}${templateBody}${templateKeywords}`)
      );
    },
    get selectedEmailTemplate(): IEmailTemplateModel | undefined {
      return self.emailTempaltes.find(({ id }) => id === self.selectedId);
    },
  }))
  .volatile(() => ({}))
  .actions((self) => ({
    normalizeEmailTemplates({ data }: AxiosResponse): IEmailTemplateModel[] {
      self.emailTempaltes.replace(data.data);
      return self.emailTempaltes;
    },
    normalizeEmail({ data }: AxiosResponse): IEmail[] {
      const templates = Array.isArray(data) ? data : data?.data || [];
      self.emailtemp.replace(templates as any);
      return self.emailtemp;
    },
    setFilter(filter: string) {
      self.filter = filter;
    },
    clearStore(): IEmailTemplateModel[] {
      self.emailTempaltes.clear();
      self.selectedId = 0;
      return self.emailTempaltes;
    },
    setSelectedId(id: number): void {
      self.selectedId = id;
    },
    clearSelected(): number {
      self.selectedId = 0;
      return self.selectedId;
    },
  }))
  .actions((self) => ({
    getEmailTemplates: flow(function* () {
      const result = yield axios
        .get<IEmailTemplateModel[]>('settings/email-templates')
        .then(self.normalizeEmailTemplates)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    updateEmailTemplate: flow(function* (data: IEmailTemplateModel) {
      const result = yield axios
        .put(`settings/email-templates/${self.selectedId}`, data)
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    getEmail: flow(function* () {
      const result = yield axios
        .get<IEmail[]>('get-template')
        .then(self.normalizeEmail)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
  }));

export type IEmailTemplatesTableStore = Instance<typeof EmailTemplatesTableStore>;
